// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.title {
  color: #003366;
  margin-top: 10px;
}
.resume-6{
  width: 796px;  /* Set fixed width to match large screen size */
  max-width: 796px; /* Ensure no resizing */
  height: auto;
  margin: 0 auto;

}
.capitalize6{
  text-transform: capitalize;
}
.button-container-6{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 0px 0rem 0 16rem;
    display: flex;
    }

.db6{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  display: block; 
  margin-left: 4rem !important;
}

.bk6{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  display: block; 
  margin-left: -5.5rem;
}
@media (max-width: 768px) {
  .db6{
    padding-top: 0px !important;
    margin-left: 0px !important;
  }
  .button-container-6{
    padding: 0px;
  }
  .bk6{
    margin-left: 0rem !important;
  }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .db6{
      margin-left: 10 rem!important;
      text-wrap: nowrap;
   
    }
    .button-container6{
    
      margin-left: 0px;
      align-items: flex-start;
    }
    .bk6{
      margin-left: 0rem !important;
    }
  }
  


h1 {
  color: #003366;
  margin-top: 20px;
  font-size: 2.5rem;
}
.pt6{
  font-size: 14px;
  color: #212529;
  text-align: justify;
  margin-bottom: 4px;
}
.subtitle6{
  font-size: 16px;
  color: #212529;
  font-weight: 500;
  margin-bottom: 1px;
}
.text-info6 {
  color: #0dcaf0 !important;
}
.bold6{
  font-weight: 500;
}

.header6 {
  text-align: center;
  margin: 4px 0;
}

.mainbox6 {
  background-color: rgb(247, 252, 252);
  padding: 20px;
  min-width: 100%; 
  display: inline-block;
  padding-bottom: 0px !important;
}
.hr-6 {
  margin: 6px 0;
  border: none;
  border-bottom: 1px solid inherit;
}
.content6 {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.temp6 {
  flex: 0 0 48%;
  text-wrap: wrap;
}

.ul6 {
  list-style-type: none;
  padding: 0;
  font-size: 14px;
  text-align: justify;
  text-wrap: wrap;
  word-wrap: break-word;
}
.upercase{
  text-transform: uppercase;
}
.hr6 {
  margin: 1px 0;
  color: #212529;
  background-color: currentColor;
  border: 0;
  opacity: .25;
  margin: 0px !important;
  padding: 0px !important;
  width: 100% !important;
}

.scroll-container6 {
  width: 100%;
  overflow-x: auto; 
  white-space: nowrap;
}



@media (min-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }

  .content6 {
    flex-direction: row;
    gap: 20px;
  }

  .temp6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
}

@media (min-width: 992px) {
  h1 {
    font-size: 2.5rem;
  }

  .resume-6 {
    padding: 20px;
  }

  .temp6 {
    flex: 0 0 48%;
  }
  .tw{
    word-break: break-word !important;
    text-wrap: wrap !important;
  }

}
.tw{
  word-break: break-word !important;
  text-wrap: wrap !important;
}
.footer6 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid #e9ecef;

}

.footer-text6 {
  font-size: 16px;
  color: #6c757d; 
  text-align: end;
  margin-right: 15px;
  margin-bottom: 2px;
}

.footer-link6 {
  color: #007bff;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp6.css"],"names":[],"mappings":";;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY,GAAG,+CAA+C;EAC9D,gBAAgB,EAAE,uBAAuB;EACzC,YAAY;EACZ,cAAc;;AAEhB;AACA;EACE,0BAA0B;AAC5B;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb;;AAEJ;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;EACA;IACE;MACE,6BAA6B;MAC7B,iBAAiB;;IAEnB;IACA;;MAEE,gBAAgB;MAChB,uBAAuB;IACzB;IACA;MACE,4BAA4B;IAC9B;EACF;;;;AAIF;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,iCAAiC;IACjC,0BAA0B;EAC5B;;AAEF;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;;AAE/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["\r\n\r\n.title {\r\n  color: #003366;\r\n  margin-top: 10px;\r\n}\r\n.resume-6{\r\n  width: 796px;  /* Set fixed width to match large screen size */\r\n  max-width: 796px; /* Ensure no resizing */\r\n  height: auto;\r\n  margin: 0 auto;\r\n\r\n}\r\n.capitalize6{\r\n  text-transform: capitalize;\r\n}\r\n.button-container-6{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 10px 0;\r\n    padding: 0px 0rem 0 16rem;\r\n    display: flex;\r\n    }\r\n\r\n.db6{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px;\r\n  display: block; \r\n  margin-left: 4rem !important;\r\n}\r\n\r\n.bk6{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px;\r\n  display: block; \r\n  margin-left: -5.5rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .db6{\r\n    padding-top: 0px !important;\r\n    margin-left: 0px !important;\r\n  }\r\n  .button-container-6{\r\n    padding: 0px;\r\n  }\r\n  .bk6{\r\n    margin-left: 0rem !important;\r\n  }\r\n  }\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db6{\r\n      margin-left: 10 rem!important;\r\n      text-wrap: nowrap;\r\n   \r\n    }\r\n    .button-container6{\r\n    \r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n    .bk6{\r\n      margin-left: 0rem !important;\r\n    }\r\n  }\r\n  \r\n\r\n\r\nh1 {\r\n  color: #003366;\r\n  margin-top: 20px;\r\n  font-size: 2.5rem;\r\n}\r\n.pt6{\r\n  font-size: 14px;\r\n  color: #212529;\r\n  text-align: justify;\r\n  margin-bottom: 4px;\r\n}\r\n.subtitle6{\r\n  font-size: 16px;\r\n  color: #212529;\r\n  font-weight: 500;\r\n  margin-bottom: 1px;\r\n}\r\n.text-info6 {\r\n  color: #0dcaf0 !important;\r\n}\r\n.bold6{\r\n  font-weight: 500;\r\n}\r\n\r\n.header6 {\r\n  text-align: center;\r\n  margin: 4px 0;\r\n}\r\n\r\n.mainbox6 {\r\n  background-color: rgb(247, 252, 252);\r\n  padding: 20px;\r\n  min-width: 100%; \r\n  display: inline-block;\r\n  padding-bottom: 0px !important;\r\n}\r\n.hr-6 {\r\n  margin: 6px 0;\r\n  border: none;\r\n  border-bottom: 1px solid inherit;\r\n}\r\n.content6 {\r\n  margin-top: 6px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n\r\n.temp6 {\r\n  flex: 0 0 48%;\r\n  text-wrap: wrap;\r\n}\r\n\r\n.ul6 {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  font-size: 14px;\r\n  text-align: justify;\r\n  text-wrap: wrap;\r\n  word-wrap: break-word;\r\n}\r\n.upercase{\r\n  text-transform: uppercase;\r\n}\r\n.hr6 {\r\n  margin: 1px 0;\r\n  color: #212529;\r\n  background-color: currentColor;\r\n  border: 0;\r\n  opacity: .25;\r\n  margin: 0px !important;\r\n  padding: 0px !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.scroll-container6 {\r\n  width: 100%;\r\n  overflow-x: auto; \r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n@media (min-width: 768px) {\r\n  h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n\r\n  .content6 {\r\n    flex-direction: row;\r\n    gap: 20px;\r\n  }\r\n\r\n  .temp6 {\r\n    flex: 0 0 48%;\r\n    max-width: 48%;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n\r\n  .resume-6 {\r\n    padding: 20px;\r\n  }\r\n\r\n  .temp6 {\r\n    flex: 0 0 48%;\r\n  }\r\n  .tw{\r\n    word-break: break-word !important;\r\n    text-wrap: wrap !important;\r\n  }\r\n\r\n}\r\n.tw{\r\n  word-break: break-word !important;\r\n  text-wrap: wrap !important;\r\n}\r\n.footer6 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid #e9ecef;\r\n\r\n}\r\n\r\n.footer-text6 {\r\n  font-size: 16px;\r\n  color: #6c757d; \r\n  text-align: end;\r\n  margin-right: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link6 {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
